/**
	 * 入力した紐付設定情報をDBに反映するために用いるVO
	 *
	 */
export class RegistRelatedDataModel {

  // 処理区分
  public processDiv: string = <string>'';

  // 処理モード
  public processMode: string = <string>'';		// "1":新規 "2":更新 "3":削除

  // 受注コード
  public orderCode: string = <string>'';

  // 代表商品コード
  public mainPCode: string = <string>'';

  // 紐付設定画面データ
  public relatedDataList: Array<any> = new Array<any>();
}
